import { Blog, brand, Transaction } from '@/commonTypes';
import { formatTehranPersianDate } from './formatTehranPersianDate';
import { lightBg, lightBgIcon } from './formats';
import MainIcons from '@/icons/main';

export function mapBlog(raw: any): Blog {
  return {
    id: raw?.id,
    title: raw?.title,
    slug: raw?.slug,
    excerpt: raw?.summary,
    viewNum: raw?.view_num,
    createdAt: raw?.created_at,
    user: raw?.writer ? { name: raw.writer } : undefined,
    category: raw?.group ? { name: raw.group.title, slug: raw.group.slug } : undefined,
    tags: raw?.tags,
    image: raw?.image,
    cover: raw?.cover,
  };
}

export function mapBrand(raw: any): brand {
  return {
    id: raw?.id,
    brand: raw?.brand,
    slug: raw?.slug,
    description: raw?.description,
    founded: raw?.founded,
    modelsCount: raw?.models_count,
    country: raw?.country ? { title: raw.country } : undefined,
    image: raw?.image,
  };
}

export function mapPaymentHistory(item: any, index: number): Transaction {
  return {
    ...item,
    category: item?.sub_category?.key ? item?.sub_category?.key : '-',
    title: item?.sub_category?.title ? item?.sub_category?.title : '',

    type_title: item?.type_title,

    date: item?.created_at ? formatTehranPersianDate(item?.created_at) : '-',
    source: item?.class_title ? item?.class_title : '-',
    code: item?.local_invoice_id ? 'کد: ' + item?.local_invoice_id : '-',
    amount: item?.amount ? item?.amount : '-',
    iconBg: lightBg(index),
    iconColor: lightBgIcon(index),
    statusId: item?.status_id ? item?.status_id : '-',
    createdAt: item?.created_at ? item?.created_at : '-',
  };
}
